import React from 'react';
import classes from './volume-meter.module.scss';
import { ReactComponent as MicrophoneIcon } from '../../../img/microphone.svg';
import useMicrophoneVolume from '../../../utils/use-microphone-volume';

interface VolumeMeterProps {
  deviceId: string;
}

const VolumeMeter = ({
  deviceId,
}: VolumeMeterProps) => {
  const volume = useMicrophoneVolume(deviceId);

  return (
    <div className={classes.volumeMeter}>
      <MicrophoneIcon className={classes.volumeMeter__icon}/>
      <div className={classes.volumeMeter__bar}>
        <div
          className={classes.volumeMeter__level}
          style={{
            width: volume + '%',
          }}
        />
      </div>
    </div>
  );
}

export default VolumeMeter;